import { createBrowserRouter, type RouteObject } from 'react-router'
import { RouteError } from '~/components/RouteError'
import { PublicLayout } from '~/layouts/PublicLayout'
import { page } from '~/routes/lazy'
import { memberRoutes } from '~/routes/member'
import { organizerPublicRoutes, organizerRoutes } from '~/routes/organizer'

/**
 * Route map (PLAN v3 §4). SHARED, FROZEN after Phase 0: the organizer area lives in routes/organizer.tsx (B1), the
 * member area in routes/member.tsx (B2); edit those modules, not this file.
 *
 *   /                      landing
 *   /organizer/...         organizer auth + dashboard   (routes/organizer.tsx)
 *   /o/:orgSlug/...        organization landing, join, member home, voting page   (routes/member.tsx)
 *   /unsubscribe           email opt-out   (routes/member.tsx)
 */
export const routeObjects: RouteObject[] = [
  {
    element: <PublicLayout />,
    errorElement: <RouteError />,
    children: [
      { index: true, lazy: page(() => import('~/pages/LandingPage')) },
      ...organizerPublicRoutes,
      ...memberRoutes,
      { path: '*', element: <RouteError /> },
    ],
  },
  organizerRoutes,
]

export const router = createBrowserRouter(routeObjects)
